module.exports = __webpack_public_path__ + "img/SY.bb614a1c.svg";